export const NON_STANDARD_SAMPLE_ALIAS = "sampleTypeOther";

type SampleWithAlias = {
    alias?: string | null,
};

export function isNonStandardSample(sample: SampleWithAlias | null | undefined): boolean {
    const alias = sample?.alias?.toLowerCase() ?? "";
    return alias === NON_STANDARD_SAMPLE_ALIAS || alias.includes("drugoe");
}

export function hasNonStandardSample(samples: SampleWithAlias[] | null | undefined): boolean {
    return samples?.some(isNonStandardSample) ?? false;
}
